import { useAppDispatch, useAppSelector } from "store/hooks";
import style from "./ControlPanel.module.scss";
import { DatePicker, Select } from "@ui";
import { setActiveEndDate, setActiveStartDate, setActiveTagFilter } from "@global-state/pages/admin/costs/slice";
import { useGetAllCostsTagsQuery } from "@RTKQuery/admin/costsTags/costsTags";

export function ControlPanel() {
    const dispatch = useAppDispatch();

    const { activeStartDate, activeEndDate, activeTagFilter } = useAppSelector(state => state.costsAdminPage);

    const { data } = useGetAllCostsTagsQuery();

    return (
        <div className={style.controlPanel}>
            <p className={style.label}>Cтатистика витрат</p>
            <div className="flex items-center gap-[10px] max-md:flex-col max-md:items-end max-sm:items-center">
                <DatePicker
                    currentDate={
                        {
                            start: activeStartDate ? activeStartDate.split("-").reverse().join(".") : "Початкова дата",
                            end: activeEndDate ? activeEndDate.split("-").reverse().join(".") : "Кінцева дата"
                        }
                    }
                    onChangeDate={(newDate, type) => {
                        const formatDate = newDate.split(".").reverse().join("-");

                        if (type === "start") {
                            dispatch(setActiveStartDate(newDate !== "Початкова дата" ? formatDate : ""))
                        }
                        if (type === "end") {
                            dispatch(setActiveEndDate(newDate !== "Кінцева дата" ? formatDate : ""))
                        }
                    }}
                />
                <Select
                    customStyle={{
                        currentValue: "!w-[200px]"
                    }}
                    currentValue={(() => {
                        const find = data?.find(item => item.id === activeTagFilter);

                        return {
                            label: find?.name || "Всі",
                            value: String(find?.id || "0")
                        }
                    })()}
                    onChange={(newValue) => {
                        dispatch(setActiveTagFilter(Number(newValue.value)))
                    }}
                    listValues={[
                        {
                            label: "Всі",
                            value: "0"
                        },
                        ...(data?.map(item => ({
                            label: "#" + item.name,
                            value: String(item.id)
                        })) || [])
                    ]}
                />
            </div>
        </div>
    )
} 